export default __webpack_public_path__ + "static/chuck-woods-53ddf3f9b3a367ac9c8173a3491eccc5.png";